// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { costCodesStyles } from "@insite/content-library/Widgets/Budget/CostCodes";
import { xButtonSharedStyles } from "@werner/App/SharedStyle/Common/ButtonsSharedStyles";
import { xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

costCodesStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", 500)} {
            width: 100%;
        }
    `,
};

costCodesStyles.saveButton = {
    ...costCodesStyles.saveButton,
    css: css`
        ${costCodesStyles.saveButton?.css}
        margin: 0;
        ${xScreen("lte", 500)} {
            width: 100%;
        }
    `,
};

costCodesStyles.removeIcon = {
    ...xButtonSharedStyles.removeIcon,
};

costCodesStyles.titleGridItems = {
    ...costCodesStyles.titleGridItems,
    width: [12, 12, 7, 7, 7],
};

costCodesStyles.buttonsGridItem = {
    ...costCodesStyles.buttonsGridItem,
    width: [12, 12, 5, 5, 5],
    css: css`
        ${costCodesStyles.buttonsGridItem?.css}
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 10px;
        ${xScreen("lte", "sm")} {
            justify-content: flex-start;
            div[class^="HiddenStyle"] {
                display: flex;
                gap: 10px;
                width: 100%;
            }
        }
        ${xScreen("lte", 500)} {
            flex-direction: column-reverse;
        }
        ${xScreen("lte", 500)} {
            div[class^="HiddenStyle"] {
                flex-direction: column-reverse;
            }
        }
    `,
};
